import { LoanDocState, TaskState } from 'gql/graphql';

export const createDocumentValidations = (tasks: any[], loanDocs: any[]) => ({
  showDocAppraisal: () => {
    const appraisal = tasks?.find(item => item.key === 'pay_appraisal');
    const appraisalDoc = loanDocs?.find(item => item.key === 'appraisal' && item.hidden !== true);
    return appraisal?.state === TaskState.Approved && appraisalDoc?.state === LoanDocState.Approved;
  },
  
  showDocTitle: () => {
    const title = tasks?.find(item => item.key === 'title_company');
    const titleDoc = loanDocs?.find(item => item.key === 'title' && item.hidden !== true);
    return (title?.state === TaskState.Approved || title?.metadata?.titleCompany === undefined) 
      && (titleDoc?.state === LoanDocState.Verified || titleDoc?.state === LoanDocState.Cleared);
  },

  showDocInsurance: () => {
    const insurance = tasks?.find(item => item.key === 'insurance');
    const insuranceDoc = loanDocs?.find(item => item.key === 'insurance' && item.hidden !== true);
    // transform state for insurance task
    const transformStateInsurance = !insuranceDoc && insurance?.metadata?.contactedApproved && insurance?.state === TaskState.Approved ? TaskState.Review : insurance?.state;
    return transformStateInsurance === TaskState.Approved && insuranceDoc?.state === LoanDocState.Approved;
  }
});